module.exports = fox._r("fonts/montserrat-hairline-webfont.woff", __webpack_public_path__ + "fonts/21S8MeN.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/montserrat-hairline-webfont.woff
// module id = 3
// module chunks = 5